import { Box, Skeleton, Stack, Typography } from '@mui/material';
import { SectionBlock } from '@schooly/style';
import { FC, useCallback } from 'react';
import { FormattedMessage } from 'react-intl';
import { useNavigate } from 'react-router-dom';
import { EmptyState } from '../../TeacherDashboardContent';
import { AssessmentsWidget } from './AssessmentsWidget';
import { ASSESSMENTS_WIDGET_TYPES, useAssessmentsWidgetQuery } from './useAssessmentsWidgetQuery';
import { useTeacherDashboardPermissions } from '../../useTeacherDashboardPermissions';

export const AssessmentsWidgetContainer: FC = () => {
  const navigate = useNavigate();

  const { canManageAssessments } = useTeacherDashboardPermissions();

  const handleNewAssessment = useCallback(() => {
    navigate('/assessments/new');
  }, [navigate]);
  const awaiting = useAssessmentsWidgetQuery('awaiting-completion');
  const upcoming = useAssessmentsWidgetQuery('upcoming');

  const isSettled = awaiting.isFetched && upcoming.isFetched;
  const hasAny = awaiting.total > 0 || upcoming.total > 0;

  if (awaiting.isLoading || upcoming.isLoading) {
    return <Skeleton variant="rectangular" sx={{ mt: 2, minHeight: 140 }} />;
  }

  if (isSettled && !hasAny) {
    return (
      <SectionBlock withCard sx={{ mt: 2 }}>
        <EmptyState
          titleId="dashboard-teacher-EmptyAssessments-title"
          subtitleId="dashboard-teacher-EmptyAssessments-subtitle"
          buttonId={canManageAssessments ? 'dashboard-teacher-EmptyAssessments-button' : undefined}
          onButtonClick={canManageAssessments ? handleNewAssessment : undefined}
        />
      </SectionBlock>
    );
  }

  return (
    <Box sx={{ mt: 0.5 }}>
      <Typography variant="h3" color="common.grey3">
        <FormattedMessage id="dashboard-teacher-MyAssessments-description" />
      </Typography>

      <Stack gap={2.75} mt={2.25}>
        {ASSESSMENTS_WIDGET_TYPES.map((type) => (
          <AssessmentsWidget key={type} type={type} />
        ))}
      </Stack>
    </Box>
  );
};
